import React from 'react'
import styled from 'styled-components'
import {
  useErrors,
  DefaultFormErrors,
  useAllSubscriptions,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { useToasts } from 'react-toast-notifications'
import { Subscription } from './Components'
import { FormError } from '../../../Common'

export const Subscriptions = () => {
  const { errorMessages, toastNotifications } = useGlobalLabels()
  const { addToast } = useToasts()
  const onSubscribeCallback = () => {
    addToast(toastNotifications?.success?.subscribe, {
      appearance: 'success',
      autoDismiss: true,
    })
  }

  const onUnsubscribeCallback = () => {
    addToast(toastNotifications?.success?.unsubscribe, {
      appearance: 'success',
      autoDismiss: true,
    })
  }

  const {
    isAllFetching,
    allSubscriptions,
    checkSubscription,
    handleClick,
    subscribeError,
    unsubscribeError,
    isLoading,
  } = useAllSubscriptions({
    onSubscribeCallback,
    onUnsubscribeCallback,
    tag: 'userprofile',
  })

  const apiErrors = useErrors<DefaultFormErrors>(
    subscribeError || unsubscribeError,
    {
      default: errorMessages?.somethingWentWrong,
    }
  )
  return (
    <Content isLoading={isLoading}>
      {!isAllFetching &&
        allSubscriptions &&
        Object.keys(allSubscriptions).map((item: string) => {
          return (
            <Subscription
              key={item}
              header={allSubscriptions[item].label}
              description={allSubscriptions[item].description}
              isChecked={checkSubscription(item)}
              handleClick={() => handleClick(item)}
            />
          )
        })}
      <FormError errors={apiErrors} fieldName="default" />
    </Content>
  )
}

const Content = styled.div<{ isLoading?: boolean }>`
  height: 8.2rem;

  ${(props) =>
    props.isLoading &&
    `
    cursor: wait;
    pointer-events: none;
  `};
`
